// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__11bVA","savePackageButton":"ClientWallet_savePackageButton__3aZIa"};